import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import Template from '../templates/template';
import TemplateImages from '../templates/template-images';

import Address from '../components/content/address';
import GoogleMap from '../components/content/google-map';

const Contact = inject("stores") (
    observer (
        class Contact extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.storeUi = this.props.stores.storeUi;

                this.state = {
                }
            }

            render() {
                return (
                    <Template>
                        <div class="container-content">
                            <div class="content-columns">
                                <div class="content-column">
                                    <h1>Contact</h1>
                                </div>
                            </div>

                            <div class="content-columns">
                                <div class="content-column  content-column--text">
                                    <Address />  
                                </div>
                                <div class="content-column content-column--images">
                                    {/* <GoogleMap /> */}
                                    <img className="single-image" src={this.urlAPI + "/adam/public/images/location.png"} /> 
                                </div>
                            </div>
                        </div>     
                    </Template>
                );
            }
        }
    )
)

export default Contact;
